module.exports = __webpack_public_path__ + "img/example-pdf.bb8bc04e.svg";